import { observable } from "mobx";
import VehicleWarningReason from "./vehicleWarningReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleChargingInstructionsResponse {
  /**
   * Vehicle warning reasons.
   */
  @observable
  warningReasons?: VehicleWarningReason[];

  /**
   * Possible exemption reason IDs.
   */
  @observable
  possibleExemptionReasonIds?: string[];
}
